var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('sign.SignForm.title'),
      "isDialogActive": _vm.isDialogActive,
      "persistent": "",
      "width": "500",
      "fullscreen": false,
      "hideLeft": true,
      "hideClose": true,
      "rightText": _vm.$t('sign.SignForm.proceedToDocument')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "rightClick": _vm.proceed,
      "close": _vm.proceed
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.signRequest.title) + " ")]), _vm.signRequest.description ? _c('v-card-subtitle', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(" " + _vm._s(_vm.signRequest.description) + " ")]) : _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.description", {
    companyName: _vm.companyName
  })) + " ")]), _c('v-card-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.explanation'))
    }
  }), _c('v-card-subtitle', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.privacy'))
    }
  }), _vm.partner && _vm.partner.settings && _vm.partner.settings.agbUrl.link ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.terms', {
        agb: _vm.partner.settings.agbUrl.link
      }))
    }
  }) : _c('span', [_vm._v(".")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }